import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import styled from 'styled-components'
import { autobind } from 'react-decoration'
import { Button } from '@components/input'
import TextField from '@components/textField'

import { actions } from 'mindself-api-client'
const { UserActions } = actions

const Title = styled.h1`
  font-size: 36px;
  color: rgba(0, 0, 0, 0.56);
  margin: 0;
  padding-bottom: 16px;
  font-weight: normal;
`

const Text = styled.span`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
  margin-top: 16px;

  & > a {
    color: #4a90e2;
    cursor: pointer;
  }
`

@connect(null, UserActions)
class LoginPage extends Component {
  state = {
    account: '',
    password: '',
  }
  @autobind
  handleChange(field) {
    return value => {
      this.setState(() => ({ [field]: value }))
    }
  }

  @autobind
  async handleSubmit() {
    const { account, password } = this.state
    const { login, isLogin } = this.props
    const loginResult = await login('email', account, password)

    const isLoginResult = await isLogin()
    const userId = isLoginResult.result

    this.props.router.push('/')
  }

  render() {
    const { className } = this.props
    const { account, password } = this.state
    return (
      <div className={cn(className, 'login-page')}>
        <img src="./assets/Mindself_logo.png" alt="logo" width="80px" />
        <Title>Log In Mindself</Title>
        <div className="text-field">
          <TextField
            value={account}
            onChange={this.handleChange('account')}
            title="USERNAME OR EMAIL"
          />
        </div>
        <div className="text-field">
          <TextField
            password
            value={password}
            onChange={this.handleChange('password')}
            title="PASSWORD"
          />
        </div>
        <div className="button">
          <Button primary text="Log In" onClick={this.handleSubmit} />
        </div>
        <Text>
          <a>Forgot your password?</a>
        </Text>
        <Text>
          Don’t have an account? <a>Get Started!</a>
        </Text>
      </div>
    )
  }
}

export default styled(LoginPage)`
  &.login-page {
    padding-top: 96px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 360px;
    margin: 0 auto;
  }

  & > img {
    border-radius: 50%;
    margin-bottom: 32.8px;
  }

  & > .text-field {
    margin-top: 16px;
    width: 100%;
  }

  & > .button {
    margin: 32px 0 8px;
    width: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/pages/login.js